import { useAuth0 } from '@auth0/auth0-react';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ROUTES } from 'Services/Route/Route.types';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import FileGeneratorModuleSettings
    from 'Components/Organisms/FileGeneratorModuleSettings/FileGeneratorModuleSettings/FileGeneratorModuleSettings';

const DashboardPage = (props: any) => {
    const { user } = useAuth0();
    const greeting = useMemo(() => {
        const hour = new Date().getHours();
        if (hour < 12) {
            return `Goedemorgen,`  
        } else if (hour < 18) {
            return `Goedemiddag,`  
        } else {
            return `Goedenavond,`  
        }
    }, [user?.nickname]);

    useEffect(() => {
        props.fetchEntities();
        props.fetchFields();
    }, []);

    return <PageTemplate>
        <Helmet>
            <title>{ROUTES.DASHBOARD.title}</title>
        </Helmet>

        <PageHeader
            breadcrumbs={
                <Breadcrumbs>
                    <BreadcrumbItem>Dashboard</BreadcrumbItem>
                </Breadcrumbs>
            }
        >
            <Title
                size='large'
                weight='bold'
            >
                Dashboard
            </Title>
        </PageHeader>

        <Container>
            <br />
            <h1 style={{fontSize: '4rem'}}>{ greeting } <span style={{textTransform: 'capitalize'}}>{user?.nickname}</span>!</h1>
        </Container>
    </PageTemplate>
}

export default connect(
    (state: any) => ({}),
    {
        fetchEntities,
        fetchFields
    }
)(DashboardPage);